import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../../components/pagehero/PageHero";
import CtaBand from "../../components/ctaband/CtaBand";
import Icon from "../../components/icons/Icons";
import "./Products.css";

const products = [
  {
    icon: "chip",
    name: "LLM Proxy",
    tags: ["secure", "enterprise ready"],
    description:
      "A gateway between your applications and LLM providers. Centralized authentication, policy enforcement, and a full audit trail for every model call.",
  },
  {
    icon: "shield",
    name: "MicroVM",
    tags: ["secure", "isolated"],
    description:
      "Hardware-isolated sandboxes for running untrusted or AI-generated code. Each session gets its own ephemeral microVM — nothing shared, nothing persisted.",
  },
  {
    icon: "badgeDollar",
    name: "CostSense",
    tags: ["finops agent"],
    description:
      "A FinOps agent that continuously watches your AWS spend, flags anomalies, and surfaces optimization opportunities before the bill arrives.",
  },
];

const Products = () => {
  return (
    <React.Fragment>
      <PageHero
        eyebrow="products"
        title="TyCloud Solutions"
        lede="Our product suite for running AI and cloud workloads securely — built on everything we've learned managing AWS infrastructure for our clients."
      />
      <section className="section-tight">
        <div className="container">
          <div className="products-grid">
            {products.map((product) => (
              <article className="card card-hover product-card" key={product.name}>
                <div className="icon-tile">
                  <Icon name={product.icon} />
                </div>
                <h2 className="product-name">{product.name}</h2>
                <div className="product-tags">
                  {product.tags.map((tag) => (
                    <span className="product-tag" key={tag}>
                      {tag}
                    </span>
                  ))}
                </div>
                <p>{product.description}</p>
                <Link to="/contact" className="link-arrow product-link">
                  request a demo
                  <Icon name="arrowRight" strokeWidth={2} />
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>
      <CtaBand />
    </React.Fragment>
  );
};

export default Products;
